import styled from 'styled-components';
import { Text16Regular } from '../../utils/Text/Text.styles';
import { Button } from '../../utils/Button/Button';

export const ModalStyle = styled.div`
  position: relative;
  outline: none;
  border-radius: 12px;
  background: #fff;
  padding: 1.2rem;
  width: 48rem;
  display: flex;
  flex-direction: column;

  @media only screen and (max-width: 500px) {
    width: 95%;
    padding: 1.2rem;
  }
`;

export const OverlayStyle = styled.div`
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 3500;
  background: rgba(0, 0, 0, 0.42);
  backdrop-filter: blur(5px);
  opacity: 0;
  transition: all 300ms ease-in-out;

  &[class*='--after-open'] {
    opacity: 1;
  }

  &[class*='--before-close'] {
    opacity: 0;
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  svg {
    cursor: pointer;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 2.4rem 0;
`;

export const Text = styled(Text16Regular)`
  line-height: 2.5rem;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 3rem;
`;

export const SaveButton = styled(Button)`
  width: unset;
  flex: 1;
  font-weight: 400;
`;

export const DiscardButton = styled(Button)`
  width: unset;
  flex: 1;
  font-weight: 400;
  border: 1px solid #d92d20;
  background: white;
  color: #d92d20;
`;
